import axios from 'axios';
import swal from 'sweetalert';

export const analyzeContracts = async (payload: any) => {
    const url = `${process.env.REACT_APP_CONTRACT_URL}/analyzeContracts`;
    try {
        const response = await axios.post(url, payload, {
            headers: {
                "Content-type": "application/json",
            },
            timeout: 60000,
        });
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message ||
            (error?.code === 'ECONNABORTED' ? 'Request timed out' : 'Analyze failed');
        swal({
            text: message,
            icon: "error",
        });
        return null;
    }
};
